/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { ClaimsSchemaOptional } from './ClaimsSchemaOptional';

export const CredentialSchema: core.serialization.ObjectSchema<
    serializers.CredentialSchema.Raw,
    Truvity.CredentialSchema
> = core.serialization.object({
    digestMultibase: core.serialization.property('digest_multibase', core.serialization.string()),
    schema: ClaimsSchemaOptional,
});

export declare namespace CredentialSchema {
    export interface Raw {
        digest_multibase: string;
        schema: ClaimsSchemaOptional.Raw;
    }
}
